import { tss } from 'tss-react';
import { useTheme } from '@mui/material/styles';

export default tss.create(() => {
  const theme = useTheme();
  return {
    progress: {
      padding: theme.spacing(1)
    }
  };
});
